const DEFAULT_SESSION_IDLE_SECONDS = 604_800;
const MINIMUM_SESSION_IDLE_SECONDS = 300;
const MAXIMUM_SESSION_IDLE_SECONDS = 604_800;

export function resolveSessionIdleMilliseconds(rawSeconds: string | undefined): number {
  const parsed = rawSeconds?.trim() ? Number(rawSeconds) : Number.NaN;
  const seconds = Number.isFinite(parsed)
    ? Math.min(MAXIMUM_SESSION_IDLE_SECONDS, Math.max(MINIMUM_SESSION_IDLE_SECONDS, parsed))
    : DEFAULT_SESSION_IDLE_SECONDS;
  return Math.round(seconds * 1_000);
}

export const browserSessionIdleMilliseconds = resolveSessionIdleMilliseconds(
  import.meta.env.VITE_SESSION_IDLE_SECONDS,
);
